import { withInstall } from '../../utils/vue-utils'
import _TimelineItem from '../timeline/src/timeline-item.vue'

export const TimelineItem = withInstall(_TimelineItem)
export type TimelineItemInstance = InstanceType<typeof _TimelineItem>
export default TimelineItem
